export default __webpack_public_path__ + "static/media/nonProfit.810b9bf7.jpeg";